import * as React from 'react';
import { Body2 } from '@cian/ui-kit';
import { IconToggleStarOn16 } from '@cian/ui-kit-design-tokens/icons';

import { TRatingColor } from './types';
import * as style from './Rating.css';

export interface IRatingDesktopProps {
  color: TRatingColor;
  score: string;
  countText: string;
}

export const RatingDesktop = ({ color, score, countText }: IRatingDesktopProps): React.JSX.Element => (
  <div className={style['container']}>
    <div className={style['score']}>
      <IconToggleStarOn16 color={color} />
      <Body2 color={color}>{score}</Body2>
    </div>
    <Body2 color="text-secondary-default">{countText}</Body2>
  </div>
);
